/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { Helmet } from "react-helmet";
import { useOrgData } from "state/OrgDataContext";
import { useAppAssetsWithSrc } from "Theme/EVENTS_ASSETS";
import { useGlobal } from "state/GeneralContext";
import { useEventTheming } from "state/AppThemingContext";
import useEventRouting from "hooks/useEventRouting";

const MetaTitle = () => {
  const EVENT_ASSETS = useAppAssetsWithSrc();
  const { dataContent: EVENT_CONTENT } = useOrgData();
  const { events } = useGlobal();
  const { eventId } = useEventRouting();
  // Per-event theme (public fetch-theme/{eventId}) carries event_title, so this works
  // logged out. The events list covers logged-in users when per-event theming is off.
  const { theming } = useEventTheming();

  const currentEvent = eventId
    ? events.find((e: any) => String(e.id) === String(eventId))
    : undefined;
  const title =
    currentEvent?.title ||
    (eventId ? theming?.event_title : undefined) ||
    EVENT_CONTENT.title;

  const favIconAsset = EVENT_ASSETS.favIcon;

  const favIconUrl = favIconAsset?.src || favIconAsset?.fallbackSrc;

  return (
    <Helmet>
      <title>{title}</title>
      {favIconUrl && <link rel="icon" href={favIconUrl} />}
      {/* {description && <meta name="description" content={description} />} */}
    </Helmet>
  );
};

export default MetaTitle;
